import clsx from 'clsx';
import { useMemo } from 'react';
import NextImage from 'next/image';

import { Content } from '@/lib';
import { getImageSizesByGridColumns } from '@/utils/getImageSizesByGridColumns';
import styles from './Image.module.scss';
import { useContentGallery } from '../ContentGallery/ContentGalleryContext';
import { Row } from '../../Row';

export function Image({ fluid, ...props }: Content.WithFluid<Content.Image>) {
  const { stretched, withBorder, withBackground, file, caption } = props;
  const { setSelectedImage } = useContentGallery();
  const aspectRatio = useMemo(() => `${(file.height / file.width) * 100}%`, [file]);
  const sizes = useMemo(() => getImageSizesByGridColumns({ desktop: fluid || stretched ? 24 : 14 }), [fluid, stretched]);
  const unoptimized = useMemo(() => /\.(gif|svg)$/.test(file.url), [file]);

  return (
    <div className={styles.wrapper}>
      <Row className={clsx(fluid && styles.fluid)}>
        <div
          className={clsx(
            styles.container,
            withBackground && styles.withBackground,
            stretched && styles.stretched,
            withBorder && styles.withBorder
          )}
        >
          <div className={clsx(styles.imageWrapper)} style={{ '--image-aspect-ratio': aspectRatio } as never}>
            <NextImage
              fill
              src={file.url}
              alt={caption}
              onClick={() => setSelectedImage(props)}
              loading="lazy"
              sizes={sizes}
              unoptimized={unoptimized}
              className={styles.image}
            />
          </div>
        </div>
      </Row>

      {!!caption && (
        <Row className={clsx(fluid && styles.fluid, stretched && styles.stretched)}>
          <span className={clsx(styles.caption, 'caption')}>{caption}</span>
        </Row>
      )}
    </div>
  );
}
